import { RequestMethodsEnum, UseBaseFetchProps, getUseBaseFetch } from '@systemeio/util'
import { useRouter } from 'next/router'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { httpClient } from 'shared/utils/http-client'

const useBaseFetch = getUseBaseFetch({
  httpClient,
  useRouter,
  useLocoTranslation,
})

export const useFetch = <M extends RequestMethodsEnum, R = void, D = any, BadRequestError = any>(
  props: UseBaseFetchProps<R, M, BadRequestError>,
) => useBaseFetch<M, R, D, BadRequestError>(props)
